import { DomainEvent } from '../../../../../core/domain/events/domain_event';
import { BillParams } from '../../bill/bill-params';

export class BillParamsEvent extends DomainEvent<BillParams> {}

export class BillParamsLogoSaved extends BillParamsEvent {}

export class BillParamsSignSaved extends BillParamsEvent {}

export class BillParamsLogoDeleted extends BillParamsEvent {}

export class BillParamsSignDeleted extends BillParamsEvent {}

export class BillParamsSaved extends BillParamsEvent {}
